
import { initSocket } from "@randajan/simple-app/fe";
import { BifrostRouter } from "@randajan/bifrost/client";
import { store } from "./bases/store";
import { page } from "./bases/page";

const socket = initSocket({
    auth:{
        storeLocale:store.get("locale"),
        queryLocale:page.pull("search.locale")
    }
});

export const bifrost = new BifrostRouter(socket, ()=>{}, true);

//export const comgateBeam = createBeam(bifrost, "/comgate/methods");

//export const gameRoomBeam = createBeam(bifrost, "/gameRoom");


export const pickUser = (stats, aliasKey)=>{
    const us = stats?.users;
    if (!us) { return; }
    const userIndex = us.index?.[aliasKey];
    return us.list?.[userIndex];
}
